import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import IdolAvatar from '@/components/ui/IdolAvatar';
import IdolName from '@/components/ui/IdolName';
import placeholder_portrait_40x40 from '@/assets/imgs/placeholders/portrait_40x40.png';

/**
 * 單行的偶像識別：頭像 + 暱稱 + 官方標記
 *
 * 呈現沿用 AppNavbar 切換偶像選單的那一列（IdolAvatar sm + IdolName sm），
 * 供表格等需要在一列內顯示偶像的地方共用。
 *
 * 名稱靠 min-w-0 + text-truncate 收縮截斷，不寫死 px —— 外層容器給多少就用多少。
 * 放在表格裡時，nowrap 名稱的整行寬度會撐寬欄位，需在 td 內包一層 .table-fill-cell（見 FanList）。
 *
 * @param {Object} idol - 偶像資料（idol_nick_name / idol_avatar_url / idol_is_official）
 * @param {Number} idolId - 有值時頭像顯示在線綠點（見 IdolAvatar），自己的偶像、管理類列表不傳
 * @param {String} to - 有值時整列包成連結（例如 /idol/:uuid），沒給就是純顯示
 * @param {String} className - 額外類名，套在頭像與名稱的那層 flex 容器上（不是外層連結）
 */
function IdolInline({ idol, idolId, to, className = '' }) {
  const content = (
    <div className={`d-flex align-items-center gap-2 min-w-0 ${className}`}>
      <IdolAvatar
        size="sm"
        src={idol.idol_avatar_url || placeholder_portrait_40x40}
        idolId={idolId}
      />
      <IdolName name={idol.idol_nick_name} isOfficial={idol.idol_is_official} />
    </div>
  );

  if (!to) return content;

  // a 的全域樣式只 reset 了 color，底線要自己拿掉
  return (
    <Link to={to} className="text-decoration-none hover-p">
      {content}
    </Link>
  );
}

IdolInline.propTypes = {
  idol: PropTypes.shape({
    idol_nick_name: PropTypes.string,
    idol_avatar_url: PropTypes.string,
    idol_is_official: PropTypes.bool.isRequired,
  }).isRequired,
  idolId: PropTypes.number,
  to: PropTypes.string,
  className: PropTypes.string,
};

export default IdolInline;
